// Modules
import React from 'react';
import { inject, observer } from 'mobx-react';

// Components
import ResponsiveAppBar from '../ResponsiveAppBar';
import ResponsiveDrawer from '../ResponsiveDrawer';

// Styles
import './style.css';

@inject('AuthStore')
@observer
export default class extends React.Component {
  state = {
    mobileOpen: false,
  };

  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };

  render() {
    return (
      <div className="root">
        <ResponsiveAppBar
          title={this.props.title}
          handleDrawerToggle={this.handleDrawerToggle}
        />
        <ResponsiveDrawer
          {...this.props}
          mobileOpen={this.state.mobileOpen}
          handleDrawerToggle={this.handleDrawerToggle}
          handleSignOut={() => this.props.AuthStore.signOut()}
        />
        <div className="content-container" style={this.props.noPadding ? { padding: 0 } : null}>
          {this.props.children}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PageChrome/index.js